import React, {useState} from 'react';
import {ArrowContainer, Popover} from "react-tiny-popover";
import {Card} from "react-bootstrap";
import PropTypes from "prop-types";
import OutletWrapper from "./OutletWrapper";

function ConfirmDelete(props) {
    const [state,setState] = useState({open:false})
    return (
        <Popover
            isOpen={state.open}
            positions={['right', 'bottom']} // if you'd like, you can limit the positions
            padding={0} // adjust padding here!
            reposition={true} // prevents automatic readjustment of content position that keeps your popover content within its parent's bounds
            //onClickOutside={() => this.setPopoverOpen(false)} // handle click events outside of the popover/target here!
            content={({position, childRect, popoverRect}) => {
                return (
                    <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
                        position={position}
                        childRect={childRect}
                        popoverRect={popoverRect}
                        arrowColor={"#eeeeee"}
                        arrowSize={10}
                        arrowStyle={{opacity: 1}}
                        className='popover-arrow-container'
                        arrowClassName='popover-arrow'
                    >

                        <Card className={'shadow p-3 bg-smoke text-center font-alt border-0 bold text-danger'}>
                            Confirm deletion
                            <div className="mt-3 d-flex justify-content-evenly gap-3">
                                <button className="btn btn-sm btn-dark" onClick={()=>{setState({...state,open:false})}}>Cancel</button>
                                <button className="btn btn-sm btn-danger" onClick={()=>{props.onDelete(props.id)}} >Delete</button>
                            </div>


                        </Card>

                    </ArrowContainer>
                )
            }}
        >
            <button onClick={()=>{setState({...state,open:true})}} className={props.className}>
                {props.children}
            </button>
        </Popover>
    );
}
ConfirmDelete.propTypes = {
    onDelete: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired
};
export default ConfirmDelete;